import { actions } from 'data'
import { InstrumentType } from 'data/types'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { getAll } from 'services/api/instrument'

export function useInstruments() {
  const [instruments, setInstruments] = useState<InstrumentType[]>([])
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()

  useEffect(() => {
    performance.mark('InstrumentsFetch:start')
    setLoading(true)
    getAll()
      .then((res) => {
        setLoading(false)
        if (!res.ok) {
          setError(true)
          return
        }
        setInstruments(res.response)
        dispatch(actions.instrument.setAll(res.response))
        performance.mark('InstrumentsFetch:done')
        performance.measure('InstrumentsFetch', 'InstrumentsFetch:start', 'InstrumentsFetch:done')
      })
      .catch(() => {
        setLoading(false)
        setError(false)
      })
  }, [])

  return {
    error, // true when there was an error fetching instruments
    instruments, // data if ready or null othrewise
    loading // true while performing the network request, false otherwise
  }
}
